import { __assign } from "tslib";
import React from "react";
import classNames from "classnames";
import { useDefaultValue } from "../form/controlled";
import { CheckContext } from "../check";
import { useConfig } from "../_util/config-context";
/**
 * 单选选项组，里面可以嵌套 <Radio />
 */
export function RadioGroup(props) {
    var classPrefix = useConfig().classPrefix;
    var _a = useDefaultValue(props), disabled = _a.disabled, layout = _a.layout, children = _a.children, value = _a.value, onChange = _a.onChange, className = _a.className, style = _a.style;
    var context = {
        inject: function (checkProps) {
            // 只为 radio 提供
            if (checkProps.type !== "radio") {
                return checkProps;
            }
            // 如果已经受控，则不注入
            if (typeof checkProps.value === "boolean") {
                return checkProps;
            }
            var checkName = checkProps.name;
            if (typeof checkName === "undefined") {
                console.warn('<Radio> managed by <RadioGroup> must include the "name" prop');
                return checkProps;
            }
            return __assign(__assign({}, checkProps), { value: value === checkProps.name, disabled: checkProps.disabled || disabled, display: layout === "column" ? "block" : "inline", onChange: function (checked, context) {
                    if (typeof checkProps.onChange === "function") {
                        checkProps.onChange(checked, context);
                        if (context.event.defaultPrevented) {
                            return;
                        }
                    }
                    if (typeof onChange === "function") {
                        onChange(checkName, context);
                    }
                } });
        },
    };
    return (React.createElement("div", { className: classNames(classPrefix + "-form-check-group", className), style: style },
        React.createElement(CheckContext.Provider, { value: context }, children)));
}
//# sourceMappingURL=RadioGroup.js.map